import classNames from "classnames";
import React from "react";
import styles from "./CourseCardGrid.scss";

/**
 * Responsive grid of CourseCards: as many ~200px columns as fit, two on phones
 */
export const CourseCardGrid = ({ className, children }) => {
    return <div className={classNames(styles.base, className)}>{children}</div>;
};
